import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  subtitle?: string
  actions?: ReactNode
  className?: string
}

export function PageHeader({
  title,
  subtitle,
  actions,
  className = '',
}: PageHeaderProps) {
  return (
    <div
      className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between ${className}`}
    >
      <div>
        {/* DESIGN.md: 헤드라인 700+ 금지 — 500 restraint가 시그니처 */}
        <h1 className="text-xl font-medium tracking-tight text-bone">
          {title}
        </h1>
        {subtitle && <p className="mt-0.5 text-sm text-ash">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  )
}
